import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, pipe, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IAccountInfoDTO } from '../../../models/IAccountInfoDTO';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AccountInfoService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  accountInfoSignal = signal<IAccountInfoDTO | null>(null);
  isLoadingData = signal(true);

  constructor() { }

  public getAccountInfo(): Observable<IAccountInfoDTO> {
    const url = `${environment.apiUrl}/v3/accounts/my-account`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<IAccountInfoDTO>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.accountInfoSignal.set(response);
        this.isLoadingData.set(false);

      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public putAccountInfo(data: IAccountInfoDTO): Observable<any> {

    const url = `${environment.apiUrl}/v3/accounts/my-account`;

    const bodyString = `accountData=${JSON.stringify(data)}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          });
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.http.put<string>(url, bodyString, {
            headers,
            responseType: 'text' as 'json'
          });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),

    )
  }
}


